<app-expansion-panel [isExpanded]="false">
    <div
        class="flex flex-row"
        header>
        <h2>
            {{ title() | transloco: { COUNT: dataToDisplay().length } }}
        </h2>
        <span class="pt-1 pl-2">
            {{ `(${dataToDisplay().length})` }}
        </span>
    </div>
    <div content>
        <div class="grid grid-cols-2">
            @for (dataError of dataToDisplay(); track dataError) {
                <span class="light-text gap-8">{{ dataError }}</span>
            }
        </div>
    </div>
</app-expansion-panel>
